module.exports = __webpack_public_path__ + "img/reset_switch_step_2.51d96d45.png";